import { FC } from 'react';
import { AuthenticationClientType } from '../../models/clientModel';
import { useCreateOrganizationAutomationClientMutation } from '../../services/clients';
import ClientCreatedModal from './components/ClientCreatedModal';
import CreateClientForm from './components/CreateClientForm';

interface Props {
	openModal: boolean;
	setOpenModal: (a: boolean) => void;
}

const CreateDeployAutomationClient: FC<Props> = ({
	openModal,
	setOpenModal,
}) => {
	const {
		data,
		mutate: createClient,
		isLoading,
	} = useCreateOrganizationAutomationClientMutation();

	const clientData = data?.data as any;
	const handleCreateClient = (values: any) => {
		createClient({
			client: {
				name: values.label,
				description: values.description,
			},
		});
	};

	return (
		<>
			{!data && (
				<CreateClientForm
					{...{
						openModal,
						setOpenModal,
						onSubmit: handleCreateClient,
						isLoading,
						clientType:
							AuthenticationClientType.OrganizationAutomationClient,
					}}
				/>
			)}
			{!!data && (
				<ClientCreatedModal
					{...{
						openModal,
						setOpenModal,
						clientType:
							AuthenticationClientType.OrganizationAutomationClient,
						client: clientData,
					}}
				/>
			)}
		</>
	);
};

export default CreateDeployAutomationClient;
